import './style.css';
import {useEffect } from 'react';
import {
  Link,
  Outlet,
  useLocation,
  useNavigate
} from 'react-router-dom';
import routes from './routes';
import { useLingui } from '@lingui/react';
import useUsersStore from 'store/users';
import useRolesStore from 'store/roles';


function Settings() {
  const { _ } = useLingui();
  const location = useLocation();
  const navigate = useNavigate();
  const [, usersStoreActions] = useUsersStore();
  const [rolesStore] = useRolesStore();

  useEffect(() => {
    const canEdit = usersStoreActions.checkAccess('CanChangeConfiguration', rolesStore.roles);
    if (location.pathname == '/settings') {
      if (canEdit) {
        navigate('general');
      } else {
        navigate('my-account');
      }
    }
  }, [location, rolesStore]);

  return(
    <div className="view settings">
      <div className="sidebar">
        <ul>
          {routes.map(route => {
            if (
              route.access &&
              !route.access.some(permission => usersStoreActions.checkAccess(permission, rolesStore.roles))
            ) return null;
            return (<li key={`link-${route.id}`}>
              <Link className={location.pathname.endsWith(route.path) ? 'active' : ''} to={route.path}>
                {_(route.trans)}
              </Link>
            </li>);
          })}
        </ul>
      </div>
      <div className="sub-view">
        <Outlet />
      </div>
    </div>
  );
}

export default Settings;
